import { Navigate } from 'react-router-dom';
import {
  PocketPhrasebookPrivacyPage,
  PocketPhrasebookSupportPage,
  PrivacyRequestsPage,
} from './routePages';
import { createPolicyPage } from './routePolicyPages';
import type { AppRouteDefinition } from './routes';

export const policyRouteDefinitions: AppRouteDefinition[] = [
  {
    key: 'cookie-policy',
    path: '/cookie-policy',
    title: 'Cookie Policy',
    description: 'Review the FlowQA cookie policy and manage consent preferences.',
    metadata: { canonicalPath: '/cookie-policy', robots: 'index,follow' },
    element: createPolicyPage('07370c92-4ecc-41fe-836e-4487b26a9aa8'),
  },
  {
    key: 'cookie-policy-html',
    path: '/cookie-policy.html',
    title: 'Cookie Policy',
    element: () => <Navigate to="/cookie-policy" replace />,
  },
  {
    key: 'privacy-requests',
    path: '/privacy-requests',
    title: 'Privacy Requests',
    description: 'Submit a FlowQA privacy request for access, deletion, or other data rights.',
    metadata: { canonicalPath: '/privacy-requests', robots: 'noindex,follow' },
    element: () => <PrivacyRequestsPage />,
  },
  {
    key: 'pocket-phrasebook-privacy',
    path: '/pocket-phrasebook/privacy',
    title: 'Pocket Phrasebook Privacy Policy',
    description:
      'Review how Pocket Phrasebook handles phrase content, feedback, analytics, subscriptions, and privacy choices.',
    metadata: { canonicalPath: '/pocket-phrasebook/privacy', robots: 'index,follow' },
    element: () => <PocketPhrasebookPrivacyPage />,
  },
  {
    key: 'pocket-phrasebook-support',
    path: '/pocket-phrasebook/support',
    title: 'Pocket Phrasebook Support',
    description:
      'Get support for Pocket Phrasebook, subscriptions, feedback, and privacy requests.',
    metadata: { canonicalPath: '/pocket-phrasebook/support', robots: 'index,follow' },
    element: () => <PocketPhrasebookSupportPage />,
  },
  {
    key: 'privacy-policy',
    path: '/privacy-policy',
    title: 'Privacy Policy',
    description: 'Review how FlowQA handles privacy, personal data, and user rights.',
    metadata: { canonicalPath: '/privacy-policy', robots: 'index,follow' },
    element: createPolicyPage('9ec55e0f-2e88-41a9-803b-5e1180513847'),
  },
  {
    key: 'privacy-policy-html',
    path: '/privacy-policy.html',
    title: 'Privacy Policy',
    element: () => <Navigate to="/privacy-policy" replace />,
  },
  {
    key: 'terms-of-service',
    path: '/terms-of-service',
    title: 'Terms of Service',
    description: 'Review the FlowQA terms of service for using the product and website.',
    metadata: { canonicalPath: '/terms-of-service', robots: 'index,follow' },
    element: createPolicyPage('6698af93-e6c9-4ffa-8f24-0ff34b3e022d'),
  },
  {
    key: 'acceptable-use-policy',
    path: '/acceptable-use-policy',
    title: 'Acceptable Use Policy',
    description: 'Review the FlowQA acceptable use policy for product and website usage.',
    metadata: { canonicalPath: '/acceptable-use-policy', robots: 'index,follow' },
    element: createPolicyPage('cea0d21a-5c0b-4a92-bd65-7501d1af6e98'),
  },
  {
    key: 'acceptable-use-policy-html',
    path: '/acceptable-use-policy.html',
    title: 'Acceptable Use Policy',
    element: () => <Navigate to="/acceptable-use-policy" replace />,
  },
  {
    key: 'terms-of-service-html',
    path: '/terms-of-service.html',
    title: 'Terms of Service',
    element: () => <Navigate to="/terms-of-service" replace />,
  },
];
